<template>
  <div class="page-report">
    <van-skeleton v-if="loadingSke" title :row="3"/>
    <template v-else>
      <div class="img-bg"></div>
      <div class="report-top">
        <img src="@/assets/images/cartojourney/img09.png" class="bg-top" alt=""/>
        <div class="top-con">
          <div class="top-left">
            <div class="con-div">
              <div class="label-div">
                <img
                  src="@/assets/images/cartojourney/img45.png"
                  v-if="isEdit"
                  class="con-label con-label3"
                  @click="handleClickJumpEdit('diseases')"
                  alt=""
                />
                <img
                  src="@/assets/images/cartojourney/img10.png"
                  v-else
                  class="con-label"
                  alt=""
                />
              </div>
              <div class="con-val diseases-val">
                {{ journeyTopDetails && journeyTopDetails.diseases }}
              </div>
            </div>
            <div class="con-div">
              <div class="label-div">
                <img
                  src="@/assets/images/cartojourney/img46.png"
                  v-if="isEdit"
                  class="con-label con-label4"
                  @click="handleClickJumpEdit('technologys')"
                  alt=""
                />
                <img
                  src="@/assets/images/cartojourney/img11.png"
                  v-else
                  class="con-label con-label2"
                  alt=""
                />
              </div>
              <div class="con-val">{{ journeyTopDetails && journeyTopDetails.technologys }}</div>
            </div>
          </div>
          <img
            class="top-right"
            src="@/assets/images/cartojourney/img12.png"
            @click="handleClickJump"
            alt=""
          />
        </div>
      </div>
      <div class="academic-activity-box">
        <div class="academic-activity" @click.stop="handleJumpActivityList">
          <img src="@/assets/images/cartojourney/icon-academic.png" class="icon-academic" alt=""/>
          <div class="academic-title">学术活动</div>
          <img src="@/assets/images/cartojourney/arrow-right.png" class="icon-right" alt=""/>
        </div>
      </div>
      <JourneySelectoVue
        :journey-maps="journeyMaps"
        :current-journey-txts="currentJourneyTxts"
        :isSurgeon="isSurgeon"
        @change="handleChangeJourney"
        @unlockJourney="unlockJourney"/>
      <JourneyStageCollapseVue
        :stages="stages"
        :hasVersionNumber="hasVersionNumber"
        :isSurgeon="isSurgeon"
        :allowEditing="allowEditing"
        :customizedCode="customizedCode"
        @edit="handleEdit"
        @unlockJourneyStages="unlockJourneyStages"
      />
      <img v-if="!hasVersionNumber" src="@/assets/images/cartojourney/img31.png" class="img-put" @click="handleSubmit"
           alt="">
    </template>
    <custom-dialog
      :visible.sync="cDialog1.visible"
      v-bind="cDialog1"
      @cancel="cDialog1.cancel"
      @confirm="cDialog1.confirm"
      @close="cDialog1.close"
    >
      <div class="txts">{{ cDialog1.content }}</div>
    </custom-dialog>
    <custom-dialog
      :visible.sync="cDialog.visible"
      @cancel="cDialog.cancel"
      @confirm="cDialog.confirm"
      @close="cDialog.close"
      v-bind="cDialog"
    >
      <div class="txts">{{ cDialog.content }}</div>
    </custom-dialog>
  </div>
</template>

<script>
import {trackPageView} from '@/utils/trace'
import withRouteTracking from '@/utils/withRouteTracking'
import {journeys, customizedStageCons, customizedPush, getjourneysByMultiCode} from '@/api/cartoJourney.js'
import JourneySelectoVue from './components/JourneySelecto.vue'
import JourneyStageCollapseVue from './components/JourneyStageCollapse.vue'
import CustomDialog from './components/CustomDialog.vue'
import {debounce} from '@/utils/util'
import {getShareInfo} from '@/utils/wxShare'
import {Toast} from 'vant'
import {customizedUnlockJourney, customizedUnlockJourneyStage} from '../../api/cartoJourney'

const UserProfile = {
  name: 'journeyPage',
  components: {
    JourneySelectoVue,
    JourneyStageCollapseVue,
    CustomDialog
  },
  data() {
    return {
      loadingSke: true,
      journeyTopDetails: {},
      journeyMaps: [],
      stages: [],
      currentJourney: {},
      currentStages: {},
      currentJourneyTxts: '电生理成长之旅',
      detial: {},
      isSubmit: true,
      isSurgeon: false,
      allowEditing: false, // 点击查看 / 编辑, 允许更改旅程下面的阶段
      isEdit: false,
      defaultTime: new Date().getTime(),
      cDialog: {
        title: '提醒',
        visible: false,
        content: '',
        cancel: () => {
          this.cDialog.visible = false
        },
        close: () => {
          this.cDialog.visible = false
        },
        confirm: () => {
        },
      },
      cDialog1: {
        title: '是否确认推送',
        visible: false,
        closeIcon: false,
        content: '推送后术者端报告将实时更新并呈现。',
        confirm: () => {
          this.handleConfirm()
        },
        cancel: () => {
          this.cDialog1.visible = false
        },
        close: () => {
          this.cDialog1.visible = false
        }
      },
    }
  },
  mounted() {
    this.customizedCode = this.$route.query.customizedCode
    this.customizedMultiCode = this.$route.query.customizedMultiCode
    this.isSurgeon = this.$route.query.isSurgeon
    const allowEditingQueryParam = this.$route.query.allowEditing
    this.allowEditing = allowEditingQueryParam === 'true'
    if (this.customizedCode) {
      this.handleGetjourneysByCode()
    } else if (this.customizedMultiCode) {
      this.handleGetjourneysByMultiCode()
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo
    },
    hasVersionNumber() {
      return this.journeyTopDetails.versionNumber
    }
  },
  methods: {
    handleGetjourneysByCode(journeyId) {
      this.isEdit = true
      journeys({customizedId: this.customizedCode}).then(res => {
        this.journeyMaps = res.data
        let selectCurrentJourney = sessionStorage.getItem('selectCurrentJourney')
        if (selectCurrentJourney) {
          this.currentJourney = JSON.parse(selectCurrentJourney)
          this.currentJourneyTxts = this.currentJourney.name
        } else {
          res.data.some(item => {
            if (item.state === '1') {
              if (journeyId) {
                if (journeyId === item.id) {
                  this.currentJourney = item
                  this.currentJourneyTxts = item.name
                  sessionStorage.setItem('selectCurrentJourney', JSON.stringify(this.currentJourney))
                }
              } else {
                this.currentJourney = item
                this.currentJourneyTxts = item.name
                sessionStorage.setItem('selectCurrentJourney', JSON.stringify(this.currentJourney))
              }
              return true // 停止进一步的迭代
            }
            return false // 继续迭代
          })
        }
        this.handleGetStagesCourses()
      })
    },
    handleGetjourneysByMultiCode(journeyId) {
      getjourneysByMultiCode({multiCode: this.customizedMultiCode}).then(res => {
        this.journeyMaps = res.data.journeyList
        this.journeyTopDetails = res.data
        this.customizedCode = res.data.id
        res.data.journeyList.map(item => {
          if (item.state === '1') {
            if (journeyId) {
              if (journeyId === item.id) {
                this.currentJourney = item
                this.currentJourneyTxts = item.name
                this.stages = item.journeyStageInfoList
              }
            } else {
              this.currentJourney = item
              this.currentJourneyTxts = item.name
              this.stages = item.journeyStageInfoList
            }
          }
        })
        this.loadingSke = false
      })
    },
    handleShareMethod() {
      window.sessionStorage.setItem('mainId', this.customizedMultiCode)
      window.sessionStorage.setItem('serviceId', this.customizedMultiCode)
      let entrance = (this.$route.query.entrance) ? this.$route.query.entrance : ''
      window.sessionStorage.setItem('entrance', entrance)
      getShareInfo({
        title: 'iEP-中国电生理术者充电站',
        titleTimeLine: 'iEP-中国电生理术者充电站',
        desc: '更智慧、更全面、更懂你。',
        link: window.location.href,
        linkTimeLine: window.location.href,
        images: `https://iep.jjmc.cn/bw/file/material/image/1933146816339349528.jpg`,
      })
    },
    handleConfirm: debounce(function (e) {
      customizedPush({customizedCode: this.customizedCode, multiCode: this.customizedMultiCode}).then(res => {
        if (res.code === 0) {
          this.$toast('推送成功！')
          setTimeout(() => {
            this.$router.push({
              path: '/surgeonList'
            })
          }, 1500)
        }
      })
    }, 500),
    handleClickJumpEdit(type) {
      let path = ''
      let query = {}
      if (type === 'diseases') {
        path = '/selectiveDisease'
        query = {
          customizedMultiCode: this.customizedMultiCode,
          customizedCode: this.customizedCode,
        }
      } else if (type === 'technologys') {
        path = '/selectiveTechnique'
        query = {
          customizedMultiCode: this.customizedMultiCode,
          customizedCode: this.customizedCode,
        }
      }
      this.$router.push({
        path,
        query
      })
    },
    handleClickJump() {
      let iepOpenId = sessionStorage.getItem('surgeonIepOpenId')
      this.$router.push({
        path: '/studyReport',
        query: {
          iepOpenId,
          typeSource: 'cartoJourney'
        }
      })
    },
    handleJumpActivityList() {
      if (this.isSurgeon) {
        this.$toast('仅支持修改课程/文献/病例！')
        return
      }
      this.$router.push({
        path: '/selectActivity',
        query: {
          customizedCode: this.customizedCode,
          customizedMultiCode: this.customizedMultiCode,
        }
      })
    },
    async handleGetAllStagesCourses() {
      // 使用 Promise.all 来等待所有异步操作完成
      await Promise.all(this.journeyMaps.map(async (item) => {
        if (`${item.state}` === '1') {
          let params = {
            customizedId: this.customizedCode,
            journeyId: item.id,
          }
          try {
            const res = await customizedStageCons(params)
            let stages = res.data.journeyStageInfoList
            if (Array.isArray(stages) && stages.length > 0) {
              for (let stage of stages) {
                if (!stage.cycle && stage.journeyStage.state === '1' && stage.journeyStage.learningStatus !== '1') {
                  console.log(stage, '23')
                  this.isSubmit = false
                  this.$toast(`存在阶段未编辑完成，请确认后推送`)
                  break // 如果找到不符合条件的阶段，可以提前退出循环
                }
              }
            }
          } catch (error) {
            console.error('Error fetching stages courses:', error)
            this.isSubmit = false
          }
        }
      }))
    },
    handleSubmit: debounce(async function () {
      await this.handleGetAllStagesCourses()
      if (this.isSubmit) {
        this.cDialog1.visible = true
      }
    }, 500),
    handleEdit(item) {
      sessionStorage.setItem('selectCourse', JSON.stringify(item.studyContent && item.studyContent.length > 0 ? item.studyContent : []))
      sessionStorage.setItem('selectCycle', JSON.stringify(item.cycle))
      this.$router.push({
        path: '/journeyEdit',
        query: {
          customizedCode: this.customizedCode,
          customizedJourneyId: this.currentJourney.id,
          customizedStageId: item.journeyStage.id,
          customizedMultiCode: this.customizedMultiCode,
          codeTxt: item.journeyStage.stageNo.substring(0, 2) === 'U4' ? 'U3' : item.journeyStage.stageNo.substring(0, 2),
          stageTxt: item.journeyStage.name,
          isSurgeon: this.isSurgeon
        }
      })
    },
    handleGetStagesCourses() {
      let params = {
        customizedId: this.customizedCode,
        journeyId: this.currentJourney.id,
      }
      if (sessionStorage.getItem('journeyStage') && Object.keys(this.journeyTopDetails).length > 0) {
        let journeyStage = JSON.parse(sessionStorage.getItem('journeyStage'))
        if (!Object.keys(journeyStage).includes(this.currentJourney.id)) {
          this.loadingSke = false
          this.stages = journeyStage[this.currentJourney.id]
        }
      }
      customizedStageCons(params).then(res => {
        this.journeyTopDetails = res.data
        this.stages = res.data.journeyStageInfoList
        if (sessionStorage.getItem('journeyStage')) {
          let journeyStage = JSON.parse(sessionStorage.getItem('journeyStage'))
          if (!Object.keys(journeyStage).includes(this.currentJourney.id)) {
            journeyStage[this.currentJourney.id] = res.data.journeyStageInfoList
            sessionStorage.setItem('journeyStage', JSON.stringify(journeyStage))
          }
        } else {
          sessionStorage.setItem('journeyStage', JSON.stringify({[this.currentJourney.id]: res.data.journeyStageInfoList}))
        }
        this.loadingSke = false
      })
    },
    unlockJourney(item) {
      if (item.manualUnlock !== 1) {
        Toast('该旅程不能手动解锁')
        return
      }
      this.cDialog.visible = true
      this.cDialog.content = '是否手动解锁该旅程？'
      this.cDialog.confirm = async () => {
        try {
          const {code} = await customizedUnlockJourney({
            'customizedId': this.customizedCode,
            'journeyId': item.id
          })
          if (code === 0) {
            Toast('解锁成功')
            if (this.customizedCode) {
              this.handleGetjourneysByCode(item.id)
            } else if (this.customizedMultiCode) {
              this.handleGetjourneysByMultiCode(item.id)
            }
          } else {
            Toast('解锁失败')
          }
        } catch (e) {
          Toast('解锁失败')
          console.error(JSON.stringify(e))
        }
        this.cDialog.visible = false
      }
    },
    unlockJourneyStages(item) {
      if (item.journeyStage.manualUnlock !== 1) {
        Toast('该阶段不能手动解锁')
        return
      }
      this.cDialog.visible = true
      this.cDialog.content = '是否手动解锁该阶段？'
      this.cDialog.confirm = async () => {
        try {
          const {code} = await customizedUnlockJourneyStage({
            'customizedId': this.customizedCode,
            'journeyId': item.journeyStage.journeyId,
            'stageId': item.journeyStage.id,
          })
          if (code === 0) {
            Toast('解锁成功')
            if (this.customizedCode) {
              this.handleGetjourneysByCode(item.journeyStage.journeyId)
            } else if (this.customizedMultiCode) {
              this.handleGetjourneysByMultiCode(item.journeyStage.journeyId)
            }
          } else {
            Toast('解锁失败')
          }
        } catch (e) {
          Toast('解锁失败')
          console.error(JSON.stringify(e))
        }
        this.cDialog.visible = false
      }
    },
    // 选择切换旅程
    async handleChangeJourney(item) {
      if (`${item.state}` === '2') return
      this.currentJourneyTxts = item.name
      this.currentJourney = this.journeyMaps.filter(item => item.name === this.currentJourneyTxts)[0]
      sessionStorage.setItem('selectCurrentJourney', JSON.stringify(this.currentJourney))
      if (this.isEdit) {
        this.handleGetStagesCourses()
      } else {
        this.stages = this.currentJourney.journeyStageInfoList
        console.log(this.stages, '23')
      }
      window.sessionStorage.setItem('traceTitle', `旅程报告-${item.name}`)
      await trackPageView(
        this.pathToFrom.to,
        this.pathToFrom.to,
        this.defaultTime
      )
      this.defaultTime = new Date().getTime()
    },
  },
}
export default withRouteTracking(UserProfile)
</script>
<style lang="less" scoped>
/deep/ .van-skeleton {
  padding-top: 20px;
  box-sizing: border-box;

  .van-skeleton__row, .van-skeleton__title {
    background-color: #fff;
  }
}

.page-report {
  background: #F9F8F7;
  min-height: 100vh;
  padding-bottom: 60px;
  box-sizing: border-box;

  .img-put {
    position: fixed;
    width: 123px;
    height: 42px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 16px;
    z-index: 9;
  }

  .img-bg {
    width: 100%;
    height: 140px;
    position: fixed;
    left: 0;
    top: 0;
  }

  .report-top {
    position: relative;
    height: 155px;
    margin-bottom: 8px;
    padding: 3px 10px 0;
    box-sizing: border-box;

    .bg-top {
      width: calc(100% - 20px);
      position: absolute;
      left: 10px;
      top: 3px;
    }

    .top-con {
      display: flex;
      position: relative;
      padding-top: 43px;
      box-sizing: border-box;

      .top-left {
        display: flex;
        flex-direction: column;
        position: relative;
        // ::after {
        //   position: absolute;
        //   right: 0;
        //   height: 100px;
        //   border-right: 1px solid rgba(0, 0, 0, 0.02);
        //   top: 0;
        //   content: "";
        // }
        .con-div {
          display: flex;
          align-items: flex-start;

          .label-div {
            width: 60px;
            min-width: 60px;
            max-width: 60px;
            margin-right: 3px;
            display: flex;
            justify-content: flex-end;

            .con-label {
              width: 34px;
              display: block;

              &.con-label2 {
                width: 45px;
              }

              &.con-label3 {
                width: 44px;
              }

              &.con-label4 {
                width: 55px;
              }
            }
          }

          .con-val {
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 500;
            font-size: 14px;
            color: #000000;
            line-height: 20px;
            width: 234px;
            height: 60px;
            display: -webkit-box;
            overflow: hidden;
            text-overflow: ellipsis;
            // white-space: nowrap;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;

            &.diseases-val {
              height: 40px;
            }
          }
        }
      }

      .top-right {
        width: 26px;
        height: 84px;
        display: block;
        margin-left: 15px;
      }
    }
  }

  .academic-activity-box {
    margin: 10px 0;
    padding: 0 10px;
    box-sizing: border-box;
    width: 100%;
    height: 58px;
    .academic-activity {
      background: url("~@/assets/images/cartojourney/bg-academic.png") no-repeat center center / 100% 100%;
      display: flex;
      align-items: center;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      border-radius: 10px;
      padding: 0 16px;
      cursor: pointer;
      .icon-academic {
        width: 32px;
        margin-right: 14px;
      }
      .academic-title {
        flex: 1;
        font-family: PingFang SC, PingFang SC;
        font-weight: 600;
        font-size: 16px;
        color: #000000;
      }
      .icon-right {
        width: 16px;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/views/cartoJourney/journeyPage.vue